/* ============================================================
   COVRPACK — Recherche v1.0 (06/10/2026)
   Fichier : assets/covrpack-search.js
   Chargé par sections/covrpack-header.liquid (toutes les pages, defer).

   1. Suggestions à la frappe sous la barre de recherche du header :
      l'API de suggestions de Shopify (/search/suggest.json) est appelée
      à partir de 2 lettres ; produits, collections, requêtes et guides.
      Les produits sont reclassés : Entrepôt Covr d'abord, puis les
      produits personnalisables, puis les entrepôts partenaires.
   2. Page de résultats : bandeau « Collections correspondantes » et
      suggestions « Essayez plutôt » quand il n'y a aucun résultat.

   Textes : window.covrStrings.search (snippets/covrpack-custom-apps.liquid,
   clés locales covrpack_search.*). Rien n'est écrit en dur sauf les
   secours en français.
   ============================================================ */
(function () {
  'use strict';

  var S = Object.assign({
    suggestions: 'Suggestions', collections: 'Collections', guides: 'Guides', products: 'Produits',
    see_all: 'Voir tous les résultats', see_all_count: 'Voir les {{ count }} résultats',
    min_chars: 'Tapez au moins 2 lettres pour voir des suggestions.', searching: 'Recherche…',
    error: 'La recherche est momentanément indisponible. Appuyez sur Entrée pour lancer la recherche.',
    warehouse: 'Entrepôt Covr', perso: 'Personnalisable', partner: 'Partenaire', from: 'dès', ht: 'HT',
    popular_searches: 'Recherches populaires', try_instead: 'Essayez plutôt :', close: 'Fermer les suggestions',
    matching_collections: 'Collections correspondantes', guide_label: 'Guide', looking_for: 'Vous cherchez plutôt :'
  }, (window.covrStrings && window.covrStrings.search) || {});

  var PERSO_VENDORS = ['Covr Perso', 'Covr Cupsz', 'Covr Rainbowcups', 'Covr Cup Print', 'Covr Vista Print'];
  // Règles « vous cherchez plutôt » : quand la requête correspond, la collection est mise en avant
  // (menu déroulant et page de résultats) avec ses 4 premiers produits. Les produits ne portent pas
  // ces mots (loi AGEC : les pots shaker sont des récipients alimentaires, pas des gobelets), donc
  // la recherche Shopify seule ne les trouverait pas. Ajouter une règle = une ligne ici.
  var RULES = [
    { match: /gobelets?\s+(en\s+)?plastique|verres?\s+(en\s+)?plastique|gobelets?\s+(pet|rpet|transparents?|jetables?\s+plastique)|pots?\s+plastique/i, handle: 'gobelets-plastique' },
    { match: /gobelets?\s+milk[- ]?shakes?|milk[- ]?shakes?/i, handle: 'gobelets-plastique' },
    // v1.1 (08/10/2026) : « couvert » → couverts de l'Entrepôt Covr (kits et couverts à l'unité) en tête.
    // Même liste dans sections/covrpack-search-results.liquid.
    { match: /^(?!.*(pochette|[ée]tui|serviette|range)).*couverts?/i, handle: 'couverts-bois-bambou', max: 12, products: [
      'kit-couvert-6-en-1', 'kit-couverts-bambou-6-en-1-17cm', 'kit-couverts-bois-4-en-1', 'kit-couverts-bambou-4-en-1-17cm',
      'kit-couverts-bois-3-en-1', 'kit-couverts-bambou-3-en-1-17cm', 'kit-couverts-bois-2-en-1',
      'fourchette-en-bois-16-cm', 'couteaux-en-bois-16-cm', 'cuilleres-en-bois-16-cm', 'petites-cuilleres-en-bois-10-cm',
      'fourchette-bois-10-5cm', 'fourchette-bambou-17cm', 'couteau-bambou-17cm', 'cuillere-bambou-17cm'] }
  ];
  var ruleCache = {};
  function ruleFor(q) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i].match.test(q)) return RULES[i];
    return null;
  }
  // Titre + 4 produits de la collection mise en avant (JSON public de la collection, langue de la page)
  function fetchRule(rule, q) {
    if (rule.products) return fetchRuleProducts(rule, q || '');
    if (ruleCache[rule.handle]) return ruleCache[rule.handle];
    var base = ROOT.replace(/\/$/, '') + '/collections/' + rule.handle;
    ruleCache[rule.handle] = Promise.all([
      fetch(base + '.json', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }),
      fetch(base + '/products.json?limit=4', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
    ]).then(function (res) {
      var col = (res[0] && res[0].collection) || {};
      var prods = ((res[1] && res[1].products) || []).map(function (p) {
        var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
        return { title: p.title, vendor: p.vendor, url: ROOT.replace(/\/$/, '') + '/products/' + p.handle,
          featured_image: p.images && p.images[0] ? { url: p.images[0].src } : null,
          price_min: prices.length ? String(Math.min.apply(null, prices)) : '' };
      });
      return { title: col.title || rule.handle, url: base, products: prods };
    }).catch(function () { return null; });
    return ruleCache[rule.handle];
  }
  // Règle à liste de produits : fiches lues une par une (/products/x.js, langue de la page), gardées en cache
  var prodCache = {};
  function fetchRuleProducts(rule, q) {
    var root = ROOT.replace(/\/$/, '');
    var list = rule.products.filter(function (h) {
      if (/bambou/i.test(q)) return /bambou/.test(h);
      if (/bois/i.test(q)) return !/bambou/.test(h);
      return true;
    });
    var key = rule.handle + '|' + list.join(',');
    if (ruleCache[key]) return ruleCache[key];
    ruleCache[key] = Promise.all([
      fetch(root + '/collections/' + rule.handle + '.json', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ].concat(list.map(function (h) {
      if (!prodCache[h]) prodCache[h] = fetch(root + '/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      return prodCache[h];
    }))).then(function (res) {
      var col = (res[0] && res[0].collection) || {};
      var prods = res.slice(1).filter(Boolean).map(function (p) {
        return { title: p.title, vendor: p.vendor, url: root + '/products/' + p.handle,
          featured_image: p.featured_image ? { url: (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image } : null,
          price_min: p.price_min != null ? String(p.price_min / 100) : '' };
      });
      return { title: col.title || rule.handle, url: root + '/collections/' + rule.handle, products: prods, max: rule.max, inline: true };
    });
    return ruleCache[key];
  }
  var WAREHOUSE_VENDOR = 'Covr Prodispal';
  var LANG = document.documentElement.lang || 'fr';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SUGGEST_URL = ROOT.replace(/\/$/, '') + '/search/suggest.json';
  var SEARCH_URL = ROOT.replace(/\/$/, '') + '/search';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tpl(str, vars) {
    return String(str).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars[k] == null ? '' : vars[k]; });
  }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return n.toLocaleString(LANG, { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }); }
    catch (e) { return n.toFixed(2) + ' €'; }
  }
  // 0 = Entrepôt Covr, 1 = personnalisable, 2 = partenaire
  function groupOf(p) {
    if (p.vendor === WAREHOUSE_VENDOR) return 0;
    // Boîtes et plateaux à œufs des vendeurs perso : pas personnalisés, sauf si le titre le dit
    if (PERSO_VENDORS.indexOf(p.vendor) !== -1 && (!/(oeuf|œuf)/i.test(p.title || '') || /personnalis/i.test(p.title || ''))) return 1;
    return 2;
  }
  function rerank(products) {
    return products.map(function (p, i) { return { p: p, i: i, g: groupOf(p) }; })
      .sort(function (a, b) { return a.g - b.g || a.i - b.i; })
      .map(function (x) { return x.p; });
  }
  // Met en gras la partie tapée dans une suggestion
  function highlight(text, q) {
    var t = esc(text);
    var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; });
    words.forEach(function (w) {
      var re = new RegExp('(' + esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      t = t.replace(re, '<mark>$1</mark>');
    });
    return t;
  }
  function cleanUrl(u) { return String(u || '').split('?')[0]; }
  // Vignette CDN Shopify : paramètre width (fonctionne pour /products/ comme pour /files/)
  function thumb(u, w) { u = String(u || ''); return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }

  function fetchSuggest(q, types, limit, signal) {
    var url = SUGGEST_URL + '?q=' + encodeURIComponent(q)
      + '&resources[type]=' + types
      + '&resources[limit]=' + limit
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    return fetch(url, { credentials: 'same-origin', signal: signal }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) { return (j.resources && j.resources.results) || {}; })
      .catch(function (e) { if (e && e.name === 'AbortError') return { aborted: true }; throw e; }); // requête remplacée par une plus récente : on ignore
  }

  /* ---------- 1. Menu déroulant du header ---------- */
  function initDropdown(form) {
    var input = form.querySelector('input[type="search"]');
    var dd = form.querySelector('[data-cvr-search-dd]');
    if (!input || !dd) return;

    var cache = {}, cacheKeys = [];
    var ctrl = null, timer = null, lastQ = '', open = false;
    var chips = Array.prototype.slice.call(document.querySelectorAll('.cvr-header__chip'));
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    if (dd.id) input.setAttribute('aria-controls', dd.id);

    function setOpen(v) {
      open = v;
      dd.hidden = !v;
      form.classList.toggle('is-open', v);
      input.setAttribute('aria-expanded', v ? 'true' : 'false');
      if (window.matchMedia('(max-width: 900px)').matches) {
        document.body.classList.toggle('cvr-search-open', v);
        if (v) {
          var r = form.getBoundingClientRect();
          document.documentElement.style.setProperty('--cvr-search-dd-top', Math.round(r.bottom + 6) + 'px');
        }
      }
      if (!v) select(-1);
    }

    function options() { return Array.prototype.slice.call(dd.querySelectorAll('[role="option"]')); }
    function select(idx) {
      var opts = options();
      opts.forEach(function (o, i) {
        var on = i === idx;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) { input.setAttribute('aria-activedescendant', o.id || ''); o.scrollIntoView({ block: 'nearest' }); }
      });
      if (idx < 0) input.removeAttribute('aria-activedescendant');
      dd._sel = idx;
    }

    function renderIdle() {
      if (!chips.length) { setOpen(false); return; }
      dd.className = 'cvr-search-dd cvr-search-dd--idle';
      dd.innerHTML = '<div class="cvr-search-dd__side"><div class="cvr-search-dd__group"><h4>' + esc(S.popular_searches) + '</h4>'
        + '<div class="cvr-search-dd__chips">' + chips.map(function (a, i) {
          return '<a role="option" id="' + dd.id + '-chip-' + i + '" href="' + esc(a.getAttribute('href')) + '">' + esc(a.textContent.trim()) + '</a>';
        }).join('') + '</div></div></div>';
      setOpen(true);
    }

    function renderLoading() {
      if (dd.querySelector('.cvr-search-dd__main')) return; // on garde l'ancien contenu pendant le chargement
      dd.className = 'cvr-search-dd cvr-search-dd--idle';
      dd.innerHTML = '<div class="cvr-search-dd__side"><div class="cvr-search-dd__loading">' + esc(S.searching) + '</div></div>';
      setOpen(true);
    }

    function sideGroup(title, items, mapFn, extraClass) {
      if (!items || !items.length) return '';
      return '<div class="cvr-search-dd__group' + (extraClass ? ' ' + extraClass : '') + '"><h4>' + esc(title) + '</h4><ul>' + items.map(mapFn).join('') + '</ul></div>';
    }

    function render(q, res) {
      var products = rerank(res.products || []);
      if (res.boost && res.boost.products.length) {
        // Produits de la collection mise en avant en tête, sans doublon
        var urls = {};
        res.boost.products.forEach(function (p) { urls[cleanUrl(p.url)] = 1; });
        products = res.boost.products.concat(products.filter(function (p) { return !urls[cleanUrl(p.url)]; }));
      }
      products = products.slice(0, (res.boost && res.boost.max) || 8);
      var queries = (res.queries || []).slice(0, 4);
      var collections = (res.collections || []).slice(0, 5);
      var articles = (res.articles || []).slice(0, 3);
      var n = 0;
      function oid() { return dd.id + '-o' + (n++); }
      var searchHref = SEARCH_URL + '?q=' + encodeURIComponent(q) + '&type=product';

      var boost = res.boost ? '<div class="cvr-search-dd__boost"><h4>' + esc(S.looking_for) + '</h4><a role="option" id="' + oid() + '" href="' + esc(res.boost.url) + '">' + esc(res.boost.title) + ' →</a></div>' : '';
      var side = boost + sideGroup(S.suggestions, queries, function (s) {
        return '<li role="option" id="' + oid() + '"><a href="' + esc(SEARCH_URL + '?q=' + encodeURIComponent(s.text) + '&type=product') + '">' + highlight(s.text, q) + '</a></li>';
      }) + sideGroup(S.collections, collections, function (c) {
        return '<li role="option" id="' + oid() + '"><a href="' + esc(cleanUrl(c.url)) + '">' + highlight(c.title, q) + '</a></li>';
      }) + sideGroup(S.guides, articles, function (a) {
        return '<li role="option" id="' + oid() + '"><a href="' + esc(cleanUrl(a.url)) + '">' + highlight(a.title, q) + '<small>' + esc(S.guide_label) + '</small></a></li>';
      }, 'cvr-search-dd__group--guides');

      var main;
      if (products.length) {
        main = '<h4>' + esc(S.products) + '</h4><ul class="cvr-search-dd__products">' + products.map(function (p) {
          var g = groupOf(p);
          var badge = g === 0 ? '<span class="cvr-search-dd__badge">' + esc(S.warehouse) + '</span>'
            : g === 1 ? '<span class="cvr-search-dd__badge cvr-search-dd__badge--perso">' + esc(S.perso) + '</span>'
            : '<span class="cvr-search-dd__badge cvr-search-dd__badge--partner">' + esc(S.partner) + '</span>';
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + esc(thumb(p.featured_image.url, 120)) + '" alt="" loading="lazy" width="56" height="56">'
            : '<span class="cvr-search-dd__noimg"></span>';
          var price = p.price_min || p.price;
          return '<li class="cvr-search-dd__product" role="option" id="' + oid() + '"><a href="' + esc(cleanUrl(p.url)) + '">' + img
            + '<span><span class="cvr-search-dd__ptitle">' + highlight(p.title, q) + '</span>'
            + '<span class="cvr-search-dd__pmeta">' + (price ? esc(S.from) + ' <strong>' + esc(money(price)) + '</strong> ' + esc(S.ht) : '') + badge + '</span></span></a></li>';
        }).join('') + '</ul>';
      } else if (!side) {
        main = '<div class="cvr-search-dd__empty"><b>' + esc(String(S.no_results_title || 'Aucun produit ne correspond à « __TERMS__ »').replace('__TERMS__', q)) + '</b>' + esc(S.no_results_text || '') + '</div>';
      } else {
        main = '';
      }
      main += '<a class="cvr-search-dd__all" role="option" id="' + oid() + '" href="' + esc(searchHref) + '">' + esc(S.see_all) + ' →</a>';

      dd.className = 'cvr-search-dd' + (side ? '' : ' cvr-search-dd--idle');
      dd.innerHTML = (side ? '<div class="cvr-search-dd__side">' + side + '</div>' : '') + '<div class="cvr-search-dd__main">' + main + '</div>';
      setOpen(true);
    }

    function run(q) {
      q = q.trim();
      if (q.length < 2) { lastQ = ''; renderIdle(); return; }
      if (q === lastQ && open) return;
      lastQ = q;
      if (cache[q]) { render(q, cache[q]); return; }
      renderLoading();
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var rule = ruleFor(q);
      Promise.all([
        fetchSuggest(q, 'product,collection,query,article', 8, ctrl && ctrl.signal),
        rule ? fetchRule(rule, q) : Promise.resolve(null)
      ]).then(function (both) {
        var res = both[0];
        if (!res || res.aborted) return;
        if (both[1]) res.boost = both[1];
        cache[q] = res; cacheKeys.push(q);
        if (cacheKeys.length > 40) delete cache[cacheKeys.shift()];
        if (input.value.trim() === q) render(q, res);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        dd.className = 'cvr-search-dd cvr-search-dd--idle';
        dd.innerHTML = '<div class="cvr-search-dd__side"><div class="cvr-search-dd__empty">' + esc(S.error) + '</div></div>';
        setOpen(true);
      });
    }

    function onType() {
      clearTimeout(timer);
      var q = input.value;
      timer = setTimeout(function () { run(q); }, 160);
    }
    input.addEventListener('input', onType);
    input.addEventListener('keyup', function (e) { if (!open && input.value.trim().length >= 2 && e.key && e.key.length === 1) onType(); });
    input.addEventListener('focus', function () { run(input.value); });
    // Le script est chargé en différé : si le visiteur tape déjà dans le champ, on ouvre sans attendre une nouvelle frappe
    if (document.activeElement === input && input.value.trim().length >= 2) run(input.value);
    input.addEventListener('keydown', function (e) {
      if (!open) { if (e.key === 'ArrowDown') { run(input.value); } return; }
      var opts = options(), cur = typeof dd._sel === 'number' ? dd._sel : -1;
      if (e.key === 'ArrowDown') { e.preventDefault(); select(Math.min(opts.length - 1, cur + 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); select(Math.max(-1, cur - 1)); }
      else if (e.key === 'Escape') { setOpen(false); }
      else if (e.key === 'Enter' && cur >= 0 && opts[cur]) {
        e.preventDefault();
        var a = opts[cur].tagName === 'A' ? opts[cur] : opts[cur].querySelector('a');
        if (a) window.location.href = a.href;
      }
    });
    document.addEventListener('click', function (e) { if (open && !form.contains(e.target)) setOpen(false); });
    form.addEventListener('submit', function () { setOpen(false); });
    window.addEventListener('resize', function () { if (open) setOpen(true); }, { passive: true });
  }

  /* ---------- 2. Page de résultats ---------- */
  function initResultsPage(root) {
    var q = root.getAttribute('data-cvr-sr') || '';
    if (q.length < 2) return;
    var colsBox = root.querySelector('[data-cvr-sr-cols]');
    var tryBox = root.querySelector('[data-cvr-sr-try]');
    var boostBox = root.querySelector('[data-cvr-sr-boost]');
    var rule = ruleFor(q);
    // Règle à liste de produits : les cartes sont déjà rendues en tête de la grille (Liquid)
    if (rule && boostBox && !rule.products) {
      fetchRule(rule).then(function (b) {
        if (!b) return;
        boostBox.innerHTML = '<h2>' + esc(S.looking_for) + ' <a href="' + esc(b.url) + '">' + esc(b.title) + ' →</a></h2>'
          + (b.products.length ? '<ul>' + b.products.map(function (p) {
            return '<li><a href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(thumb(p.featured_image.url, 96)) + '" alt="" loading="lazy" width="48" height="48">' : '<span></span>')
              + '<span><b>' + esc(p.title) + '</b>' + (p.price_min ? '<small>' + esc(S.from) + ' ' + esc(money(p.price_min)) + ' ' + esc(S.ht) + '</small>' : '') + '</span></a></li>';
          }).join('') + '</ul>' : '');
        boostBox.hidden = false;
      });
    }
    if (!colsBox && !tryBox) return;
    fetchSuggest(q, 'collection,query', 6).then(function (res) {
      var cols = (res.collections || []);
      if (colsBox && cols.length) {
        colsBox.innerHTML = '<span>' + esc(S.matching_collections) + '</span>' + cols.map(function (c) {
          return '<a href="' + esc(cleanUrl(c.url)) + '">' + esc(c.title) + '</a>';
        }).join('');
        colsBox.hidden = false;
      }
      var qs = (res.queries || []).filter(function (s) { return s.text.toLowerCase() !== q.toLowerCase(); });
      if (tryBox && qs.length) {
        tryBox.innerHTML = '<span>' + esc(S.try_instead) + '</span>' + qs.map(function (s) {
          return '<a href="' + esc(SEARCH_URL + '?q=' + encodeURIComponent(s.text) + '&type=product') + '">' + esc(s.text) + '</a>';
        }).join('');
        tryBox.hidden = false;
      }
    }).catch(function () { /* silencieux : la page reste utilisable */ });
  }

  function init() {
    document.querySelectorAll('form[data-cvr-search]').forEach(initDropdown);
    var sr = document.querySelector('[data-cvr-sr]');
    if (sr) initResultsPage(sr);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
